import * as React from "react";
import Metatags from "@ADC/components/Metatags";
import NotFoundPage from "@ADC/components/Pages/404Page/NotFoundPage";

const NotFound = () => <NotFoundPage />;

export default NotFound;

export const Head = () => (
  <Metatags
    pageTitle="Error 404: Page not found"
    metaTitle="Error 404: Page not found"
    description="You just hit a page that doesn&#39;t exist..."
  />
);
